<template>
  <!-- 第一步：企业基础信息登记 -->
  <div class="firstStep">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="150px"
      class="form-wrap"
      :disabled="!ifEdit"
    >
      <el-form-item label="企业名称：" prop="name">
        <el-input v-model="form.name" placeholder="请输入" clearable disabled />
      </el-form-item>
      <el-form-item label="企业规模：" prop="scale">
        <el-select v-model="form.scale" placeholder="请选择" clearable>
          <el-option
            v-for="item in scaleList"
            :key="item.uuid"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属市、县（区）：" prop="regionValue">
        <el-cascader
          v-model="form.regionValue"
          :options="regionOptions"
          placeholder="请选择"
          :props="{ multiple: false }"
          clearable
          @change="changeRegion"
          style="width: 100%;"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="所在产业：" prop="typeFlag">
        <el-select v-model="form.typeFlag" placeholder="请选择" clearable @change="changeTypeFlag">
          <el-option
            v-for="item in typeFlagList"
            :key="item.uuid"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所在行业：" prop="industry">
        <el-select v-model="form.industry" placeholder="请选择" clearable>
          <el-option
            v-for="item in industryList"
            :key="item.uuid"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业性质：" prop="nature">
        <el-select v-model="form.nature" placeholder="请选择" clearable>
          <el-option
            v-for="item in natureList"
            :key="item.uuid"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人：" prop="contact">
        <el-input v-model="form.contact" placeholder="请输入" clearable />
      </el-form-item>
      <el-form-item label="电话：" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入" clearable />
      </el-form-item>
      <el-form-item label="邮箱：" prop="mailbox">
        <el-input v-model="form.mailbox" placeholder="请输入" clearable />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  getIndexDictionaryData,
  firstSave,
  firstInfo,
  getCurrentInfo
} from "@/utils/interface";
import ningxia from "@/utils/ningxia";
const form = () => {
  return {
    name: "", // 企业名称
    scale: "", // 企业规模
    province: "", // 所在省份
    regionValue: [], // 所在省、市、区
    city: "", // 所在城市
    area: "", // 所在区域
    typeFlag: "", // 所在产业
    industry: "", // 所在行业
    nature: "", // 企业性质
    contact: "", // 联系人
    phone: "", // 电话
    mailbox: "" // 邮箱
  };
};
export default {
  name: "",
  components: {},
  props: {
    ifEdit: {
      type: Boolean,
      default: false
    } // 是否是可编辑状态，即上云申请只保存未提交,false为不可编辑，true为可编辑
  },
  data() {
    const rules = () => {
      return {
        name: [
          { required: true, message: "请输入申企业名称", trigger: "blur" }
        ],
        scale: [
          { required: true, message: "请选择企业规模", trigger: "change" }
        ],
        regionValue: [
          { required: true, message: "请选择所在区域", trigger: "change" }
        ],
        typeFlag: [
          { required: true, message: "请选择所在产业", trigger: "change" }
        ],
        industry: [
          { required: true, message: "请选择所在行业", trigger: "blur" }
        ],
        nature: [
          { required: true, message: "请选择企业性质", trigger: "change" }
        ],
        contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        mailbox: [{ required: true, message: "请输入邮箱", trigger: "blur" }]
      };
    };
    return {
      form: form(),
      rules: rules(),
      regionOptions: ningxia,
      natureList: [], // 企业性质
      typeFlagList: [
        { name: "第一产业", uuid: "1" },
        { name: "第二产业", uuid: "2" },
        { name: "第三产业", uuid: "3" }
      ], // 所在产业
      industryList: [], // 所在产业
      industryList1: [], // 第一产业所在行业
      industryList2: [], // 第二产业所在行业
      industryList3: [], // 第三产业所在行业
      scaleList: [], // 企业规模
      uuid: "" // 当前条保存后的uuid
    };
  },
  watch: {
    // ifEdit(val) {
    //   if (val) {
    //     console.log("可以编辑");
    //   }
    // }
  },
  computed: {},
  created() {},
  mounted() {
    this.form.name = this.$store.state.isUsermessage.enterpriseName;
    this.getCompanyType();
    this.getCurrentInfo();
    if (this.$route.query.uuid) {
      this.getFirstInfo();
    }
  },
  methods: {
    /* 获取当前登录企业的信息 */
    getCurrentInfo() {
      getCurrentInfo().then(res => {
        if (res && Object.keys(res).length > 0) {
          this.form.contact = res.contact;
          this.form.phone = res.contactTel;
          this.form.mailbox = res.contactMail;
        } else {
          this.form = form();
        }
      });
    },
    /* 第一步保存 */
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = {
            userUuid: this.$store.state.isUsermessage.uuid,
            userName: this.$store.state.isUsermessage.name,
            uuid: this.uuid,
            ...this.form
          };
          firstSave(params).then(res => {
            if (res.success) {
              this.$message({
                message: res.message,
                type: "success"
              });
              this.uuid = res.data.uuid;
              this.$parent.getRegisterId(res.data.uuid);
              this.$parent.activeStep++;
            } else {
              this.$message({
                message: res.message,
                type: "error"
              });
            }
          });
        }
      });
    },
    /* 第一步详情 */
    getFirstInfo() {
      firstInfo(this.$route.query.uuid).then(res => {
        if (res.success && Object.keys(res.data).length > 0) {
          this.form = res.data;
          this.changeTypeFlag(res.data.typeFlag, "detail");
          this.getRegion();
        } else {
          this.form = form();
          this.form.name = this.$store.state.isUsermessage.enterpriseName;
        }
      });
    },
    /* 获取企业性质、企业规模、第一产业下行业、第二产业下行业、第三产业下行业 */
    getCompanyType() {
      getIndexDictionaryData({
        groupCode: "enterprise_type"
      }).then(res => {
        this.natureList = res;
      });
      getIndexDictionaryData({
        groupCode: "enterprise_scale"
      }).then(res => {
        this.scaleList = res;
      });
      getIndexDictionaryData({
        groupCode: "FIRST_INDUSTRY"
      }).then(res => {
        this.industryList1 = res;
      });
      getIndexDictionaryData({
        groupCode: "SECOND_INDUSTRY"
      }).then(res => {
        this.industryList2 = res;
      });
      getIndexDictionaryData({
        groupCode: "THIRD_INDUSTRY"
      }).then(res => {
        this.industryList3 = res;
      });
    },
    /* 改变产业 */
    changeTypeFlag(val, detail) {
      if (val) {
        switch (val) {
          case "第一产业":
            this.industryList = this.industryList1;
            break;
          case "第二产业":
            this.industryList = this.industryList2;
            break;
          case "第三产业":
            this.industryList = this.industryList3;
            break;
        }
        this.$parent.getTypeFlag(val);
        if (!detail) {
          // 不是详情状态赋值时，不清空所关联的行业
          this.form.industry = "";
        }
      } else {
        this.form.industry = "";
        this.industryList = [];
      }
    },
    /* 改变省/区/市 */
    changeRegion(val) {
      //   console.log(val);
      if (val) {
        this.form.province = val[0];
        this.form.city = val[1];
        this.form.area = val[2];
      } else {
        this.form.province = "";
        this.form.city = "";
        this.form.area = "";
      }
    },
    /* 回显省/区/市 */
    getRegion() {
      this.form.regionValue = [
        this.form.province,
        this.form.city,
        this.form.area
      ];
    }
  }
};
</script>
<style lang="less" scoped>
.firstStep {
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseCloudUp/component/firstStep.vue